module.exports = __webpack_public_path__ + "static/img/2.4713ecf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/sp/2.png
// module id = S+11
// module chunks = 0